<template>
  <div class="">
    <div class="row">
      <div class="col-md-12 col-sm-8">
        <div class="card card-default widget animated">
          <div class="card-heading">
            <form v-on:submit="createConversation">
              <div class="col-md-5 ">
                <h5>Information</h5>
                <br>
                <form-text ref="name" label="Name" name="name" v-model="conversation.title" validation="required"></form-text>
                <br>
                <h5>Members</h5>
                <p>* These mobile devices, intercoms, and users are allowed to send messages in this conversation.</p>
                <br>
                <v-select placeholder="Members" multiple :options="allWireUsers" label="name" name="members" :value.sync="conversation.members"></v-select>
                <br>
                <br> 
                <br>
                <div class="form-group">
                    <button type="submit" class="btn btn-success btn-lg">Create</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div><!-- /.col-md-9 -->
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import VeeValidate from 'vee-validate';
import VueMask from 'v-mask'
import FormText from '../../elements/Form/FormText'
import database from '../../webmaster/Database/database'
import vSelect from 'vue-select'
import firebase from 'firebase'
import store from '../../webmaster/Store/vuex'
Vue.use(VueMask);
Vue.use(VeeValidate);

export default {
  name: 'createconversation',
  components:{
    'form-text':FormText,
    vSelect
  },
  data () {
    return {
      org: store.state.usermain,
      allWireUsers: {},
      conversation: {
        title: '',
        members: [],
      },
    }
  },
  created:function(){
    //Populate wireUsers
    var ref = '/orgs/' + this.$store.state.usermain.curOrg.id + '/wire/users';
    this.$bindAsArray('allWireUsers', database.getRef(ref));
  },
  methods: {
    createConversation:function(e){
      e.preventDefault()
      let promises = [];
      var self = this;
      for (let child in this.$refs) promises.push(this.$refs[child].$validator.validateAll());
      Promise.all(promises).then(this.$validator.validateAll()).then(() => { 
        var newConversation = {
          title: self.conversation.title,
          members: {}
        }

        var curOrgId = self.$store.state.usermain.curOrg.id
        var newConversationKey = database.getDb().ref().child('orgs/' + curOrgId + '/wire/chats').push().key;
        
        var updates = {};

        self.conversation.members.forEach(function (conversationMember) {
          newConversation.members[conversationMember['.key']] = conversationMember['name'];

          updates['/orgs/' + curOrgId + '/wire/users/' + conversationMember['.key'] + '/chats/' + newConversationKey] = {
            title: self.conversation.title,
          };
        });
        
        updates['/orgs/' + curOrgId + '/wire/chats/' + newConversationKey] = newConversation;

        database.getDb().ref().update(updates, function(){
          self.$router.push('/operations/wire')
        });
      }, () => {});
    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  
</style>



// WEBPACK FOOTER //
// CreateConversation.vue?e41b367a